import React, {useEffect, useState} from 'react';
import {getProductTokenById, getProductTokenByProductName} from "../../services/ProductRepository";
import {Outlet, useNavigate, useOutletContext, useParams} from "react-router-dom";
import {CourseDashboardHeader} from "../../components/CourseDashboardHeader";
import {useError} from "../../hooks/useError";
import Header from "../../components/navigation/Header";
import {setProductName} from "../../services/AxiosConfig";


export function CourseDashboard() {
    const {courseId, product, token} = useOutletContext()
    if (product != null && token != null) {
        return (
            <div>
                <Header/>
                <div className={"row "} style={{minHeight:"100vh"}}>
                    <div className={"col-2 border-end "} >
                        <CourseDashboardHeader name={product.name} courseId={courseId} token={token}/>
                    </div>
                    <div className={"col bg-light"}>
                        <div className={"container pt-4"}>
                                <Outlet context={{
                                    product: product,
                                    courseId: courseId,
                                    token: token
                                }}/>

                        </div>
                    </div>

                </div>
            </div>

        );
    }

}